import { useEffect } from 'react';
import useGtmResetOnRouteChange from './useGtmResetOnRouteChange';
import gtmDataLayerHandler from '../utils/gtmDataLayerHandler';
const GtmGlobal = ({ route, siteName, mainPlaceholderName, errorHandler }) => {
    useGtmResetOnRouteChange();
    useEffect(() => {
        gtmDataLayerHandler(route, siteName, mainPlaceholderName, errorHandler);
    }, []);
    return null;
};
export default GtmGlobal;
